import { render, staticRenderFns } from "./PopularItem.vue?vue&type=template&id=4691f382&scoped=true"
import script from "./popular-item.js?vue&type=script&lang=js&external"
export * from "./popular-item.js?vue&type=script&lang=js&external"
import style0 from "./popularItem.scss?vue&type=style&index=0&id=4691f382&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691f382",
  null
  
)

export default component.exports